<template>
  <div>
    <div class="mb-3 d-flex align-items-center justify-content-between">
      <div class="section-title mb-0">Guests</div>

      <button
        class="btn btn-primary btn-sm btn-add px-3 py-2"
        @click="openAddInviteeChooser"
        v-if="eventType === 'new'"
      >
        <i class="fas fa-user-plus mr-1"></i> Add Invitee
      </button>

      <button
        class="btn btn-primary btn-sm btn-add px-3 py-2"
        @click="openAddInviteeChooser"
        v-else-if="eventType === 'old'"
      >
        <i class="fas fa-user-plus mr-1"></i> Add Attended Guests
      </button>
    </div>

    <div class="card">
      <div class="card-body p-0">
        <ul class="list-group">
          <li
            class="list-group-item guest mb-2"
            v-for="m in localMembers"
            :key="m.id"
          >
            <img
              class="avatar"
              :src="m.user_img || 'https://dummyimage.com/100x100/222/fff.png&text=A'"
              alt=""
            />
            <div class="flex-grow-1">
              <div class="d-flex align-items-center">
                <div>
                  <p class="name mr-2 mb-0">{{ m.name || '-' }}</p>

                  <p class="handle mb-0" v-if="m.username">
                    <i class="fas fa-at ml-2 mr-1"></i>{{ m.username }}
                  </p>

                  <template v-else>
                    <template v-if="m.email && m.phone">
                      <p class="handle mb-0">
                        <i class="fas fa-envelope ml-2 mr-1"></i>{{ m.email }}
                      </p>
                      <p class="handle mb-0">
                        <i class="fas fa-phone ml-2 mr-1"></i>{{ m.code }}
                        {{ m.phone }}
                      </p>
                    </template>
                    <p class="handle mb-0" v-else-if="m.email">
                      <i class="fas fa-envelope ml-2 mr-1"></i>{{ m.email }}
                    </p>
                    <p class="handle mb-0" v-else-if="m.phone">
                      <i class="fas fa-phone ml-2 mr-1"></i>{{ m.code }}
                      {{ m.phone }}
                    </p>
                  </template>
                </div>
                <div></div>
              </div>

              <!-- status --> 
              <div class="meta mb-1" v-if="eventType === 'new'">
                <div v-if="m.source == 'web'">Joined with Public Link</div>
                <div v-else>Added by {{ m.from_username || '—' }}</div>
                <div v-if="m.sent_status == 1 && m.read_status == 1">
                  <p class="mb-0 small text-success" v-if="m.status == 1">
                    <i class="fas fa-check-double mr-1"></i>
                    <span v-if="rsvpFamilyEnabled">YES • ADULTS : {{ m.adult }}, CHILDREN: {{ m.child }}</span>
                    <span v-else>YES</span>
                  </p>
                  <p class="mb-0 small" style="color:red;" v-else-if="m.status == 2">
                    <i class="fas fa-check-double mr-1"></i>
                    <span v-if="rsvpFamilyEnabled">NO • ADULTS : {{ m.adult }}, CHILDREN: {{ m.child }}</span>
                    <span v-else>NO</span>
                  </p>
                  <p class="mb-0 small text-primary" v-else-if="m.status == 3">
                    <i class="fas fa-check-double mr-1"></i>
                    <span v-if="rsvpFamilyEnabled">MAY BE • ADULTS : {{ m.adult }}, CHILDREN: {{ m.child }}</span>
                    <span v-else>MAY BE</span>
                  </p>
                </div>
                <div v-else-if="m.sent_status == 1 && m.read_status == 0">
                  <p class="text-success mb-0">
                    <i class="fas fa-check mr-1"></i> Invite Sent
                  </p>
                </div>
              </div>

              <div class="meta mb-1" v-else>
                <div v-if="m.sent_status == 1 && m.read_status == 0">
                  <p class="mb-0 small text-success" v-if="m.status == 1">
                    <i class="fas fa-check-double mr-1"></i>
                    <span v-if="rsvpFamilyEnabled">YES • ADULTS : {{ m.adult }}, CHILDREN: {{ m.child }}</span>
                    <span v-else>YES</span>
                  </p>
                  <p class="mb-0 small" style="color:red;" v-else-if="m.status == 2">
                    <i class="fas fa-check-double mr-1"></i>
                    <span v-if="rsvpFamilyEnabled">NO • ADULTS : {{ m.adult }}, CHILDREN: {{ m.child }}</span>
                    <span v-else>NO</span>
                  </p>
                  <p class="mb-0 small text-primary" v-else-if="m.status == 3">
                    <i class="fas fa-check-double mr-1"></i>
                    <span v-if="rsvpFamilyEnabled">MAY BE • ADULTS : {{ m.adult }}, CHILDREN: {{ m.child }}</span>
                    <span v-else>MAY BE</span>
                  </p>
                </div>
              </div>



            </div>

            <div class="ml-2">
              <div class="dropdown">
                <button class="dot-btn" data-toggle="dropdown">
                  <i class="fas fa-ellipsis-v"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <!-- NEW style -->
                  <template v-if="eventType === 'new'">
                    <template v-if="m.edit_delete_option == 1">
                      <template v-if="m.sent_status == 1">
                        <a class="dropdown-item" href="#" @click.prevent="confirmSendChoice(m, true)">
                          <i class="fas fa-paper-plane mr-2"></i>ReSend
                        </a>
                        <a class="dropdown-item" href="#" @click.prevent="openContactModal('edit', m)">
                          <i class="fas fa-edit mr-2"></i>Update Contact
                        </a>
                        <a class="dropdown-item" href="#" @click.prevent="openUpdateRSVP(m)" v-if="rsvpEnabled">
                          <i class="fas fa-users mr-2"></i>Update RSVP
                        </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item text-danger" href="#" @click.prevent="openDeleteModal(m)">
                          <i class="fas fa-trash mr-2"></i>Delete
                        </a>
                      </template>
                      <template v-else>
                        <a class="dropdown-item" href="#" @click.prevent="confirmSendChoice(m, false)">
                          <i class="fas fa-paper-plane mr-2"></i>Send
                        </a>
                        <a class="dropdown-item" href="#" @click.prevent="openContactModal('edit', m)">
                          <i class="fas fa-edit mr-2"></i>Update Contact
                        </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item text-danger" href="#" @click.prevent="openDeleteModal(m)">
                          <i class="fas fa-trash mr-2"></i>Delete
                        </a>
                      </template>
                    </template>
                    <template v-else>
                      <template v-if="m.sent_status == 1">
                        <a class="dropdown-item" href="#" @click.prevent="confirmSendChoice(m, true)">
                          <i class="fas fa-paper-plane mr-2"></i>ReSend
                        </a>
                        <a class="dropdown-item" href="#" @click.prevent="openUpdateRSVP(m)" v-if="rsvpEnabled">
                          <i class="fas fa-users mr-2"></i>Update RSVP
                        </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item text-danger" href="#" @click.prevent="openDeleteModal(m)">
                          <i class="fas fa-trash mr-2"></i>Delete
                        </a>
                      </template>
                      <template v-else>
                        <a class="dropdown-item" href="#" @click.prevent="confirmSendChoice(m, false)">
                          <i class="fas fa-paper-plane mr-2"></i>Send
                        </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item text-danger" href="#" @click.prevent="openDeleteModal(m)">
                          <i class="fas fa-trash mr-2"></i>Delete
                        </a>
                      </template>
                    </template>
                  </template>

                  <!-- OLD style -->
                  <template v-else>
                    <a class="dropdown-item" href="#" @click.prevent="openContactModal('edit', m)">
                      <i class="fas fa-edit mr-2"></i>Update Contact
                    </a>
                    <a class="dropdown-item" href="#" @click.prevent="openUpdateRSVP(m)" v-if="rsvpEnabled">
                      <i class="fas fa-users mr-2"></i>Update RSVP
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item text-danger" href="#" @click.prevent="openDeleteModal(m)">
                      <i class="fas fa-trash mr-2"></i>Delete
                    </a>
                  </template>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div v-if="!localMembers.length" class="text-center p-4">
          <p class="text-muted mb-0">No guests yet.</p>
        </div>
      </div>

      <!-- ===== Add Invitee Chooser Modal (first step) ===== -->
      <div
        v-if="showAddChooser"
        class="cm-overlay"
        @click.self="closeAddInviteeChooser"
      >
        <div class="cm-modal" role="dialog" aria-modal="true" :aria-label="chooserTitle">
          <div class="cm-header d-flex align-items-center justify-content-between">
            <h6 class="mb-0">{{ chooserTitle }}</h6>
            <button class="cm-close" @click="closeAddInviteeChooser">&times;</button>
          </div>
          <div class="cm-body text-center">
            <button class="chooser-btn btn btn-outline-dark border w-100 mb-3"
                    @click="goToContactList">
              <span class="chooser-icon mr-2"><i class="far fa-address-book"></i></span>
              Contact List
            </button>
            <button class="chooser-btn btn btn-primary w-100"
                    @click="chooseAddContact">
              <span class="chooser-icon mr-2"><i class="fas fa-user-plus"></i></span>
              Add Contact
            </button>
          </div>
        </div>
      </div>

      <!-- ===== Delete modal ===== -->
      <div
        v-if="showDeleteModal"
        class="cm-overlay"
        @click.self="closeDeleteModal"
      >
        <div class="cm-modal" role="dialog" aria-modal="true" aria-label="Delete guest">
          <div class="cm-header d-flex align-items-center justify-content-center">
            <h6 class="mb-0">
              Are you sure you want to remove “{{ deleteTarget?.name || deleteTarget?.username || 'guest' }}”?
            </h6>
          </div>
          <div class="cm-body text-center">
            <div v-if="deleteTarget?.edit_delete_option == 1">
              <button
                class="btn btn-warning btn-sm px-3 py-1 w-75"
                :disabled="deletingGuest || deletingForever"
                @click="confirmDeleteGuest(true)"
              >
                <span v-if="deletingGuest" class="spinner-border spinner-border-sm mr-1"></span>
                Remove From Contact List
              </button>
              <button
                class="btn btn-danger btn-sm px-3 py-1 w-75 mt-3"
                :disabled="deletingGuest || deletingForever"
                @click="confirmDeleteGuest(false)"
              >
                <span v-if="deletingForever" class="spinner-border spinner-border-sm mr-1"></span>
                Remove From Guest List
              </button>
            </div>
            <div v-else-if="deleteTarget?.edit_delete_option == 0">
              <button
                class="btn btn-danger btn-sm px-3 py-1 w-50"
                :disabled="deletingGuest || deletingForever"
                @click="confirmDeleteGuest(false)"
              >
                <span v-if="deletingForever" class="spinner-border spinner-border-sm mr-1"></span>
                Remove From Guest List
              </button>
            </div>
            <div v-else>
              <button class="btn btn-light btn-sm px-3 py-1 w-50" disabled>
                No action available
              </button>
            </div>
            <button class="btn btn-light btn-sm px-3 py-1 w-50 mt-2" @click="closeDeleteModal">
              Cancel
            </button>
          </div>
        </div>
      </div>

      <!-- ===== Update RSVP modal ===== -->
      <div
        v-if="showRSVPModal"
        class="cm-overlay"
        @click.self="closeRSVPModal"
      >
        <div class="cm-modal" role="dialog" aria-modal="true" aria-label="Update RSVP">
          <div class="cm-header d-flex align-items-center justify-content-between">
            <h6 class="mb-0">Update RSVP</h6>
            <button class="cm-close" @click="closeRSVPModal">&times;</button>
          </div>
          <div class="cm-body">
            <div class="mb-3" v-if="rsvpEnabled">
              <label class="d-block font-weight-bold mb-1">Status</label>
              <div class="btn-group w-100 btn-group-toggle">
                <label class="btn btn-outline-success btn-sm w-100" :class="{ active: rsvpForm.status === 1 }">
                  <input type="radio" autocomplete="off" :checked="rsvpForm.status === 1" @change="rsvpForm.status = 1" />
                  Yes
                </label>
                <label class="btn btn-outline-danger btn-sm w-100 ml-2" :class="{ active: rsvpForm.status === 2 }">
                  <input type="radio" autocomplete="off" :checked="rsvpForm.status === 2" @change="rsvpForm.status = 2" />
                  No
                </label>
                <label class="btn btn-outline-primary btn-sm w-100 ml-2" :class="{ active: rsvpForm.status === 3 }">
                  <input type="radio" autocomplete="off" :checked="rsvpForm.status === 3" @change="rsvpForm.status = 3" />
                  Maybe
                </label>
              </div>
            </div>

            <div class="form-row" v-if="rsvpFamilyEnabled">
              <div class="form-group col-6">
                <label>Adults</label>
                <input type="number" min="0" class="form-control" v-model.number="rsvpForm.adult" :disabled="isRSVPNo" />
              </div>
              <div class="form-group col-6">
                <label>Children</label>
                <input type="number" min="0" class="form-control" v-model.number="rsvpForm.child" :disabled="isRSVPNo" />
              </div>
            </div>

            <div class="form-group mb-0">
              <label class="small" for="guest-rsvp-notes">Notes (optional)</label>
              <textarea
                id="guest-rsvp-notes"
                class="form-control"
                rows="3"
                v-model.trim="rsvpForm.notes"
                placeholder="Add any notes for the host"
              ></textarea>
            </div>
          </div>
          <div class="cm-footer d-flex justify-content-end gap-2">
            <button class="btn btn-light btn-sm" @click="closeRSVPModal">Cancel</button>
            <button class="btn btn-primary btn-sm" :disabled="savingRSVP" @click="submitRSVP">
              <span v-if="savingRSVP" class="spinner-border spinner-border-sm mr-1"></span>
              Update
            </button>
          </div>
        </div>
      </div>

      <!-- ===== Contact (Add/Edit Invitee) modal ===== -->
      <div
        v-if="showContactModal"
        class="cm-overlay"
        @click.self="closeContactModal"
      >
        <div class="cm-modal" role="dialog" aria-modal="true" :aria-label="addModalTitle">
          <div class="cm-header d-flex align-items-center justify-content-between">
            <h6 class="mb-0">{{ addModalTitle }}</h6>
            <button class="cm-close" @click="closeContactModal">&times;</button>
          </div>
          <div class="cm-body">
            <div class="form-group">
              <label>Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model.trim="contactForm.name" />
            </div>

            <div class="form-row">
              <div class="form-group col-5">
                <label>Phone Code</label>
                <div class="phonecode-wrap">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search code/country"
                    v-model.trim="countryQuery"
                    @focus="pcOpen = true"
                    @input="pcOpen = true"
                  />
                  <div v-if="pcOpen" class="pc-dropdown">
                    <div
                      v-for="c in filteredCountries"
                      :key="c.code"
                      class="pc-item"
                      @click="pickCountry(c)"
                    >
                      <span>{{ c.flag }} {{ c.name }}</span>
                      <span class="pc-dial">+{{ c.dial }}</span>
                    </div>
                    <div v-if="!filteredCountries.length" class="pc-empty">No matches</div>
                  </div>
                </div>
              </div>

              <div class="form-group col-7">
                <label>Phone</label>
                <input
                  type="tel"
                  class="form-control"
                  v-model.trim="contactForm.phone"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  maxlength="10"
                  @input="sanitizePhone"
                  @keydown="onKeydownNumeric"
                  @paste="onPasteNumeric"
                  placeholder="10-digit number"
                />
              </div>
            </div>

            <div class="form-group">
              <label>Email</label>
              <input type="email" class="form-control" v-model.trim="contactForm.email" />
            </div>

            <div v-if="contactError" class="alert alert-warning py-1">{{ contactError }}</div>
            <p class="small text-muted mb-0"><strong>Note:</strong> Email or Phone is required.</p>
          </div>
          <div class="cm-footer d-flex justify-content-end gap-2">
            <button class="btn btn-light btn-sm" @click="closeContactModal">Cancel</button>
            <button class="btn btn-primary btn-sm" :disabled="savingContact" @click="submitContact">
              <span v-if="savingContact" class="spinner-border spinner-border-sm mr-1"></span>
              {{ contactMode === 'edit' ? 'Update' : 'Add' }}
            </button>
          </div>
        </div>
      </div>
    </div> <!-- /card -->
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import api from '@/services/api'

export default {
  name: 'GuestsList',
  props: {
    members: { type: Array, default: () => [] },
    eventId: { type: [String, Number], required: true },
    eventType: { type: String, default: 'new' },
    rsvpOption: { type: [String, Number], default: '0' },
    rsvpFamily: { type: [String, Number], default: '0' },
    sessionUserId: { type: [String, Number], default: '' }
  },
  emits: ['changed'],
  setup(props, { emit }) {
    const router = useRouter()

    const localMembers = ref([])
    watch(
      () => props.members,
      v => (localMembers.value = Array.isArray(v) ? [...v] : []),
      { immediate: true }
    )

    const normalizeFlag = (val) => {
      const s = String(val ?? '').trim().toLowerCase()
      if (s === '1' || s === 'yes' || s === 'true') return true
      return Number(s) === 1
    }
    const rsvpEnabled = computed(() => normalizeFlag(props.rsvpOption))
    const rsvpFamilyEnabled = computed(() => normalizeFlag(props.rsvpFamily))

    const toast = (icon, title) =>
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon,
        title,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true
      })

    /* ---------------- Guests reload ---------------- */
    async function getGuestsList() {
      try {
        const fd = new FormData()
        fd.append('userid', props.sessionUserId || '')
        fd.append('eventid', String(props.eventId))
        const res = await api.getInvitationDetail?.(fd)
        const payload = res?.data ?? res
        const guestsArray = Array.isArray(payload?.data)
          ? payload.data
          : Array.isArray(payload?.data?.data)
          ? payload.data.data
          : []
        if (Array.isArray(guestsArray)) {
          localMembers.value = [...guestsArray]
        }
      } catch (e) {
        console.error('Failed to refresh guest list', e)
      }
    }

    /* ---------------- Add Invitee Chooser ---------------- */
    const showAddChooser = ref(false)
    const chooserTitle = computed(() =>
      props.eventType === 'old' ? 'Add Attended Invitee' : 'Add Invitee'
    )
    function openAddInviteeChooser() {
      showAddChooser.value = true
    }
    function closeAddInviteeChooser() {
      showAddChooser.value = false
    }
    function chooseAddContact() {
      showAddChooser.value = false
      openContactModal('add')
    }
    function goToContactList() {
      showAddChooser.value = false
      // adjust this route if your app uses a different path
      router.push(`/guest/${props.eventId}`)
    }

    /* ---------------- Delete Guest ---------------- */
    const showDeleteModal = ref(false)
    const deleteTarget = ref(null)
    const deletingGuest = ref(false)
    const deletingForever = ref(false)
    function openDeleteModal(m) { deleteTarget.value = m; showDeleteModal.value = true }
    function closeDeleteModal() { showDeleteModal.value = false; deleteTarget.value = null; deletingGuest.value = false; deletingForever.value = false }

    async function confirmDeleteGuest(isForever) {
      if (!deleteTarget.value) return
      try {
        if (isForever) deletingForever.value = true
        else deletingGuest.value = true

        const fd = new FormData()
        fd.append('userid', props.sessionUserId || '')
        fd.append('eventid', props.eventId)
        fd.append('id', deleteTarget.value.id)

        let res
        if (isForever) {
          res = (await api.DeleteForever?.(fd)) || (await api.deleteGuest?.(fd)) || (await api.removeContact?.(fd))
        } else {
          res = (await api.DeleteGuest?.(fd)) || (await api.deleteGuestList?.(fd)) || (await api.removeGuest?.(fd))
        }
        const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
        if (!ok) throw new Error('request failed')

        closeDeleteModal()
        await getGuestsList()
        emit('changed')
        toast('success', isForever ? 'Removed from contact list' : 'Removed from guest list')
      } catch (e) {
        console.error('Delete guest error:', e)
        toast('error', 'Could not delete guest')
      } finally {
        deletingGuest.value = false
        deletingForever.value = false
      }
    }

    /* ---------------- RSVP Update ---------------- */
    const showRSVPModal = ref(false)
    const savingRSVP = ref(false)
    const rsvpTarget = ref(null)
    const rsvpForm = ref({ status: 1, adult: 0, child: 0, notes: '' })
    const isRSVPNo = computed(() => rsvpForm.value.status === 2)
    watch(() => rsvpForm.value.status, s => { if (s === 2 && rsvpFamilyEnabled.value) { rsvpForm.value.adult = 0; rsvpForm.value.child = 0 } })
    function openUpdateRSVP(m) {
      if (!rsvpEnabled.value) return
      rsvpTarget.value = m
      const adult = rsvpFamilyEnabled.value ? Number(m.adult) || 0 : 0
      const child = rsvpFamilyEnabled.value ? Number(m.child) || 0 : 0
      const notes = m?.note || m?.notes || m?.response_note || ''
      rsvpForm.value = { status: Number(m.status) || 1, adult, child, notes }
      showRSVPModal.value = true
    }
    function closeRSVPModal() { showRSVPModal.value = false; rsvpTarget.value = null; savingRSVP.value = false }
    async function submitRSVP() {
      if (!rsvpTarget.value) return
      try {
        const totalParty = Number(rsvpForm.value.adult||0) + Number(rsvpForm.value.child||0)
        if (rsvpFamilyEnabled.value && rsvpForm.value.status !== 2 && totalParty <= 0) {
          toast('error', 'Enter at least 1 Adult or 1 Kid')
          return
        }
        savingRSVP.value = true
        const fd = new FormData()
        fd.append('userid', props.sessionUserId || '')
        fd.append('eventid', props.eventId)
        fd.append('phone', rsvpTarget.value.phone || '')
        fd.append('email', rsvpTarget.value.email || '')
        fd.append('memberid', rsvpTarget.value.id)
        fd.append('status', String(rsvpForm.value.status))
        fd.append('adult', String(rsvpFamilyEnabled.value ? (rsvpForm.value.adult || 0) : 0))
        fd.append('child', String(rsvpFamilyEnabled.value ? (rsvpForm.value.child || 0) : 0))
        fd.append('notes', rsvpForm.value.notes || '')
        const res = (await api.updateRSVP?.(fd)) || (await api.updateRsvp?.(fd))
        const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
        if (!ok) throw new Error('bad status')

        await getGuestsList()
        emit('changed')
        closeRSVPModal()
        toast('success', 'RSVP updated')
      } catch (e) {
        console.error('RSVP update failed:', e)
        toast('error', 'Failed to update RSVP')
      } finally {
        savingRSVP.value = false
      }
    }

    /* ---------------- Add/Edit Contact ---------------- */
    const showContactModal = ref(false)
    const contactMode = ref('add')
    const contactForm = ref({ id:null, name:'', email:'', phone_code:'+91', phone:'', username:'', contact_id:null })
    const savingContact = ref(false)
    const contactError = ref('')
    const addModalTitle = computed(() => (contactMode.value === 'edit' ? 'Update Contact' : 'Add Invitee'))

    function openContactModal(mode, m=null) {
      contactMode.value = mode
      contactError.value = ''
      if (mode === 'edit' && m) {
        contactForm.value = {
          id: m.id ?? null,
          name: m.name || '',
          email: m.email || '',
          phone_code: m.phone_code || m.code || '+91', // prefill code
          phone: m.phone || '',
          username: m.username || '',
          contact_id: m.contact_id ?? null,
        }
        const match = countries.value.find(c => `+${c.dial}` === contactForm.value.phone_code)
        countryQuery.value = match ? `${match.flag} ${match.name} (+${match.dial})` : contactForm.value.phone_code
      } else {
        contactForm.value = { id:null, name:'', email:'', phone_code:'+91', phone:'', username:'', contact_id:null }
        countryQuery.value = ''
      }
      showContactModal.value = true
    }
    function closeContactModal() { showContactModal.value = false; savingContact.value = false }

    function sanitizePhone() { contactForm.value.phone = (contactForm.value.phone||'').replace(/\D/g,'').slice(0,10) }
    function onKeydownNumeric(e){
      const allow = ['Backspace','Delete','Tab','Escape','Enter','ArrowLeft','ArrowRight','Home','End']
      if (allow.includes(e.key)) return
      if (!/^\d$/.test(e.key)) e.preventDefault()
      const val = String(contactForm.value.phone||'')
      if (val.length >= 10) e.preventDefault()
    }
    function onPasteNumeric(e){
      e.preventDefault()
      const text = (e.clipboardData||window.clipboardData)?.getData?.('text') || ''
      contactForm.value.phone = text.replace(/\D/g,'').slice(0,10)
    }
    function validateContact() {
      contactError.value = ''
      if (!contactForm.value.name?.trim()) { contactError.value = 'Name is required.'; return false }
      const hasEmail = !!contactForm.value.email?.trim()
      const hasPhone = !!contactForm.value.phone?.trim()
      if (!hasEmail && !hasPhone) { contactError.value = 'Provide at least one contact: email or phone.'; return false }
      if (hasPhone && contactForm.value.phone.length !== 10) { contactError.value = 'Phone must be 10 digits.'; return false }
      if (hasEmail && !/^\S+@\S+\.\S+$/.test(contactForm.value.email)) { contactError.value = 'Please enter a valid email address.'; return false }
      return true
    }
    async function submitContact() {
      try {
        if (!validateContact()) return
        savingContact.value = true

        let res
        if (contactMode.value === 'edit') {
          const fd = new FormData()
          fd.append('userid', props.sessionUserId || '')
          fd.append('eventid', props.eventId)
          if (contactForm.value.id) fd.append('guestid', contactForm.value.id)
          if (contactForm.value.contact_id) fd.append('contact_id', contactForm.value.contact_id)
          fd.append('name', contactForm.value.name)
          fd.append('email', contactForm.value.email || '')
          fd.append('phone', contactForm.value.phone || '')
          fd.append('phone_code', contactForm.value.phone_code || '')
          res = await (api.editGuest?.(fd) || api.editGuest?.(fd))
        } else {
          const fd = new FormData()
          fd.append('userid', props.sessionUserId || '')
          fd.append('eventid', props.eventId)
          fd.append('name', contactForm.value.name)
          fd.append('email', contactForm.value.email || '')
          fd.append('phone', contactForm.value.phone || '')
          fd.append('code', contactForm.value.phone_code || '')
          res = await (api.addGuestNew?.(fd) || api.addGuest?.(fd))
          const ok1 = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
          if (ok1) {
            const fd2 = new FormData()
            fd2.append('userid', props.sessionUserId || '')
            fd2.append('eventid', props.eventId)
            fd2.append('names[]', contactForm.value.name || '')
            fd2.append('emails[]', contactForm.value.email || '')
            fd2.append('phones[]', contactForm.value.phone || '')
            fd2.append('codes[]', contactForm.value.phone_code || '')
            fd2.append('contact_ids[]', contactForm.value.contact_id || '')
            res = await api.addGuest?.(fd2)
          }
        }

        const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
        if (!ok) throw new Error('save failed')

        await getGuestsList()
        emit('changed')
        closeContactModal()
        toast('success', contactMode.value === 'edit' ? 'Contact updated' : 'Invitee added')
      } catch (e) {
        console.error('Save contact failed:', e)
        contactError.value = 'Something went wrong. Please try again.'
        toast('error', 'Failed to save contact')
      } finally {
        savingContact.value = false
      }
    }

    /* ---------------- SEND / RESEND with SweetAlert ---------------- */
    function defaultSmsBody(m) {
      return `Hi ${m.name || ''}, you've been invited! Please check your invitation link.`
    }

    async function sendEmail(m, isResend) {
      const fd = new FormData()
      fd.append('userid', props.sessionUserId || '')
      fd.append('eventid', props.eventId)
      fd.append('memberid', m.id)
      fd.append('email', m.email)

      const res = isResend
        ? (await (api.resendInvite?.(fd) || api.resendInvite?.(fd)))
        : (await (api.sendInvite?.(fd)   || api.resendInvite?.(fd)))

      const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
      if (ok) {
        await getGuestsList()
        emit('changed')
        toast('success', isResend ? 'Email resent' : 'Email sent')
      } else {
        toast('error', 'Failed to send email')
      }
    }

    async function sendSms(m, isResend, smsText) {
      const fd = new FormData()
      fd.append('userid', props.sessionUserId || '')
      fd.append('eventid', props.eventId)
      fd.append('memberid', m.id)
      fd.append('phone', m.phone)
      if (m.code) fd.append('code', m.code)
      if (smsText) fd.append('message', smsText)

      const res = isResend
        ? (await (api.resendInvitePhone?.(fd) || api.resendInvitePhone?.(fd)))
        : (await (api.sendInvitePhone?.(fd)   || api.resendInvitePhone?.(fd)))

      const ok = res?.status === true || res?.data?.status === true || res?.data?.status === 'ok'
      if (ok) {
        await getGuestsList()
        emit('changed')
        toast('success', isResend ? 'SMS resent' : 'SMS sent')
      } else {
        toast('error', 'Failed to send SMS')
      }
    }

    async function confirmSendChoice(m, isResend) {
      const hasEmail = !!m.email
      const hasPhone = !!m.phone
      const hasUsername = !!m.username

      if (hasUsername) {
        if (!hasEmail) {
          await Swal.fire({
            icon: 'info',
            title: 'Email required',
            text: 'Add an email address to send an invitation to @username users.'
          })
          return
        }
        const ok = await Swal.fire({
          title: isResend ? 'Resend invitation' : 'Send invitation',
          text: `Send email to ${m.email}?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: isResend ? 'Resend Email' : 'Send Email'
        })
        if (ok.isConfirmed) await sendEmail(m, isResend)
        return
      }

      if (hasEmail && !hasPhone) {
        const ok = await Swal.fire({
          title: isResend ? 'Resend invitation' : 'Send invitation',
          text: `Send email to ${m.email}?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: isResend ? 'Resend Email' : 'Send Email'
        })
        if (ok.isConfirmed) await sendEmail(m, isResend)
        return
      }
      if (!hasEmail && hasPhone) {
        const { value: smsText, isConfirmed } = await Swal.fire({
          title: isResend ? 'Resend SMS' : 'Send SMS',
          input: 'textarea',
          inputLabel: `Message to ${m.code || ''} ${m.phone}`,
          inputValue: defaultSmsBody(m),
          inputAttributes: { 'aria-label': 'Type your message here' },
          showCancelButton: true,
          confirmButtonText: isResend ? 'Resend SMS' : 'Send SMS'
        })
        if (isConfirmed) await sendSms(m, isResend, smsText)
        return
      }

      const { value: choice } = await Swal.fire({
        title: isResend ? 'Resend Invitation' : 'Send Invitation',
        input: 'radio',
        inputOptions: {
          sms: `Send SMS to ${m.code || ''} ${m.phone}`,
          email: `Send Email to ${m.email}`,
          both: 'Send Email & SMS'
        },
        inputValidator: v => (!v ? 'Please choose an option' : undefined),
        showCancelButton: true,
        confirmButtonText: 'Continue'
      })
      if (!choice) return

      if (choice === 'email') {
        const ok = await Swal.fire({
          title: isResend ? 'Resend email?' : 'Send email?',
          text: m.email,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: isResend ? 'Resend Email' : 'Send Email'
        })
        if (ok.isConfirmed) await sendEmail(m, isResend)
      } else if (choice === 'sms') {
        const { value: smsText, isConfirmed } = await Swal.fire({
          title: isResend ? 'Resend SMS' : 'Send SMS',
          input: 'textarea',
          inputLabel: `Message to ${m.code || ''} ${m.phone}`,
          inputValue: defaultSmsBody(m),
          showCancelButton: true,
          confirmButtonText: isResend ? 'Resend SMS' : 'Send SMS'
        })
        if (isConfirmed) await sendSms(m, isResend, smsText)
      } else if (choice === 'both') {
        const ok = await Swal.fire({
          title: isResend ? 'Resend email as well?' : 'Send email as well?',
          text: m.email,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: isResend ? 'Resend Email' : 'Send Email'
        })
        if (!ok.isConfirmed) return
        await sendEmail(m, isResend)

        const { value: smsText, isConfirmed } = await Swal.fire({
          title: isResend ? 'Resend SMS' : 'Send SMS',
          input: 'textarea',
          inputLabel: `Message to ${m.code || ''} ${m.phone}`,
          inputValue: defaultSmsBody(m),
          showCancelButton: true,
          confirmButtonText: isResend ? 'Resend SMS' : 'Send SMS'
        })
        if (isConfirmed) await sendSms(m, isResend, smsText)
      }
    }

    /* ---------------- Country picker (custom, searchable) ---------------- */
    const countryQuery = ref('')
    const pcOpen = ref(false)
    const countries = ref([
      { code: 'IN', name: 'India', dial: '91', flag: '🇮🇳' },
      { code: 'US', name: 'United States', dial: '1', flag: '🇺🇸' },
      { code: 'GB', name: 'United Kingdom', dial: '44', flag: '🇬🇧' },
      { code: 'AE', name: 'United Arab Emirates', dial: '971', flag: '🇦🇪' },
      { code: 'AU', name: 'Australia', dial: '61', flag: '🇦🇺' },
      { code: 'CA', name: 'Canada', dial: '1', flag: '🇨🇦' },
    ])
    const filteredCountries = computed(() => {
      const q = countryQuery.value.trim().toLowerCase()
      if (!q) return countries.value
      return countries.value.filter(c =>
        c.name.toLowerCase().includes(q) ||
        c.code.toLowerCase().includes(q) ||
        c.dial.includes(q.replace('+',''))
      )
    })
    function pickCountry(c) {
      contactForm.value.phone_code = `+${c.dial}`
      countryQuery.value = `${c.flag} ${c.name} (+${c.dial})`
      pcOpen.value = false
    }

    // Close dropdown on outside click
    const onDocClick = e => {
      const el = e?.target
      if (!(el instanceof Element)) return
      if (!el.closest('.phonecode-wrap')) pcOpen.value = false
    }
    onMounted(() => document.addEventListener('click', onDocClick))
    onBeforeUnmount(() => document.removeEventListener('click', onDocClick))

    return {
      localMembers,

      // chooser
      showAddChooser, chooserTitle, openAddInviteeChooser, closeAddInviteeChooser, chooseAddContact, goToContactList,

      // delete
      showDeleteModal, deleteTarget, deletingGuest, deletingForever,
      openDeleteModal, closeDeleteModal, confirmDeleteGuest,

      // rsvp
      rsvpEnabled, rsvpFamilyEnabled,
      showRSVPModal, rsvpForm, isRSVPNo, savingRSVP,
      openUpdateRSVP, closeRSVPModal, submitRSVP,

      // contact
      showContactModal, contactMode, contactForm, contactError, savingContact,
      addModalTitle,
      openContactModal, closeContactModal, submitContact,
      sanitizePhone, onKeydownNumeric, onPasteNumeric,

      // send/resend
      confirmSendChoice,

      // country picker
      countryQuery, filteredCountries, pickCountry, pcOpen
    }
  }
}
</script>


<style scoped>
/* list */
.guest{ display:flex;align-items:flex-start; padding:.8rem .5rem;border-bottom:1px solid rgba(0,0,0,.06); }
.guest:last-child{border-bottom:0;}
.avatar{ width:42px;height:42px;border-radius:50%;object-fit:cover;margin-right:.75rem; box-shadow:0 1px 5px rgba(0,0,0,.1); }
.guest .name{font-weight:600; margin-bottom:0;}
.guest .handle{color:#888; font-size:.85rem;}
.guest .meta{font-size:.85rem; color:#888;}
.dot-btn{border:none;background:transparent;padding:.3rem .45rem;}

/* modal shell */
.cm-overlay{ position: fixed; inset: 0; background: rgba(0,0,0,.45); display: flex; align-items: center; justify-content: center; z-index: 1060; }
.cm-modal{ width: 100%; max-width: 520px; background: #fff; border-radius: .5rem; box-shadow: 0 10px 30px rgba(0,0,0,.2); position: relative; }
.cm-header,.cm-footer{ padding: .75rem 1rem; background: #f8f9fa; }
.cm-body{ padding: 1rem; }
.cm-close{ border: 0; background: transparent; font-size: 1.25rem; line-height: 1; }
.gap-2{ gap: .5rem; }

/* chooser buttons (to resemble screenshot spacing) */
.chooser-btn{
  padding: .9rem 1rem;
  border-radius: 999px;
  font-weight: 600;
}
.chooser-icon{ width: 1.25rem; display:inline-flex; justify-content:center; }

/* phone code searchable dropdown */
.phonecode-wrap{ position: relative; }
.pc-dropdown{
  position:absolute; z-index: 3000; left:0; right:0; top:100%;
  background:#fff; border:1px solid #e5e5e5; border-radius:.35rem;
  max-height:220px; overflow:auto; box-shadow:0 8px 24px rgba(0,0,0,.12);
}
.pc-item{
  display:flex; align-items:center; justify-content:space-between;
  padding:.45rem .6rem; cursor:pointer;
}
.pc-item:hover{ background:#f7f7f7; }
.pc-dial{ font-weight:600; }
.pc-empty{ padding:.5rem .6rem; color:#888; font-size:.9rem; }
</style>
